import React from 'react'
import { FileData } from '@/types'
import { Button } from '@/components/ui/Button'
import { Download } from 'phosphor-react'
import { downloadCertificate, getCertificateContent } from '@/utils/certificate-utils'

interface SingleCertificateDisplayProps {
  certificate: FileData
  showContent?: boolean
}

export const SingleCertificateDisplay: React.FC<SingleCertificateDisplayProps> = ({
  certificate,
  showContent = true,
}) => {
  const handleDownload = () => {
    downloadCertificate(certificate)
  }

  return (
    <div className="p-4 bg-[var(--color-gray-50)] border border-[var(--color-border)] rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-[var(--color-text-primary)]">
          Certificat actuel
        </h4>
        <Button onClick={handleDownload} variant="outline" size="sm">
          <Download className="w-4 h-4 mr-2" weight="regular" />
          Télécharger
        </Button>
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <span className="text-xs text-[var(--color-text-secondary)]">Fichier:</span>
          <span className="text-xs font-medium text-[var(--color-text-primary)]">
            {certificate.filename}
          </span>
        </div>
        {showContent && (
          <div>
            <span className="text-xs text-[var(--color-text-secondary)] block mb-1">
              Contenu (base64):
            </span>
            <div className="p-2 bg-white border border-[var(--color-border)] rounded text-xs font-mono text-[var(--color-text-primary)] break-all max-h-32 overflow-y-auto">
              {getCertificateContent(certificate)}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

